import React from 'react';
import '../styles/PDFStyle.css';
import * as phone from '../util/PhoneNumber';

export default function PDFTemplate({ QRCode, organization, description }) {
  const address = `${organization.address.city}, ${organization.address.state}`;

  return (
    <div className="mainCard">
      <div className="mainCardTop">
        <div className="getOn">
          <div className="qrCode">
            <img alt="Qrcode" src={QRCode} height="110" width="200" />
          </div>
          <div className="getOnDesc">
            <h3>Get on our VIP list</h3>
          </div>
        </div>
        <div className="scanQr">
          <h5>Scan the qr code or text</h5>
          <h4>"{organization.keyword}"</h4>
          <h5>
            to {phone.formatPhoneNumber(organization.phoneNumber || organization.campaignPhoneNumber)}
          </h5>
        </div>
      </div>
      <div className="textUp">
        <p>{description}</p>
        {/* <p>
          Text up to $
          {price.output(configurations.firstTimeRecipientCredit, true)}{" "}
          discounts at {organization.name} to your friends through Check This
          Out and save ${price.output(configurations.affiliateCredit, true)} on
          your next {organization.name} visit with each discount redeemed!
        </p> */}
        <div className="checkFooter">
          <div className="checkThis">
            <h5>CheckThisOut.io</h5>
          </div>

          <div className="checkThisRight">
            <div className="checkThisLogo">
              <img
                alt="Logo"
                src={`data:image/jpeg;base64,${organization.base64_logoUrl}`}
              />
              <div>
                <h5>{organization.name}</h5>
                <p>{address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
